import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  HostListener,
  OnChanges,
  SimpleChanges,
  ViewChildren,
  ElementRef,
  QueryList,
  AfterViewInit,
  ChangeDetectorRef,
  forwardRef,
} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-multi-select-input',
    template: `
    <div class="ngx-dropdown-container" tabindex="0">
      <button
        type="button"
        class="ngx-dropdown-button"
        [ngClass]="{disabled: disabled}"
        [disabled]="disabled"
        (click)="toggleSelectDropdown()"
      >
        <span>{{ selectedDisplayText }}</span>
        <span class="nsdicon-angle-down"></span>
      </button>
      <div class="ngx-dropdown-list-container" *ngIf="toggleDropdown" [style.maxHeight]="config.height" [class.drop-up]="config.dropUp">
        <div class="search-container" *ngIf="config.search">
          <input
            name="search"
            [(ngModel)]="searchText"
            (input)="onSearchChanged($event.target.value)"
            autocomplete="off"
          />
          <label [ngClass]="{active: searchText}">
            <span class="nsdicon-search"></span>
            {{ config.searchPlaceholder }}
          </label>
        </div>
        <ul class="selected-items">
          <li tabindex="-1" *ngFor="let selected of selectedItems; let i = index" (click)="deselectItem(selected, i)">
            <span class="nsdicon-close"></span>
            <span>{{ selected[config.displayKey] || selected }}</span>
          </li>
        </ul>
        <hr *ngIf="selectedItems.length > 0 && availableItems.length > 0" />
        <ul class="available-items">
          <li
            #availableOption
            *ngFor="let item of availableItems; let i = index"
            tabindex="-1"
            [ngClass]="{active: focusedItemIndex == i}"
            (click)="selectItem(item, i)"
          >
            {{ item[config.displayKey] || item }}
          </li>
          <li *ngIf="showNotFound">{{ config.noResultsFound }}</li>
        </ul>
      </div>
    </div>
  `,
    styles: [
        `
      .ngx-dropdown-container {
        width: 100%;
        position: relative;
        button {
          display: inline-block;
          margin-bottom: 0;
          line-height: 1.42857143;
          vertical-align: middle;
          touch-action: manipulation;
          cursor: pointer;
          user-select: none;
          border: 1px solid #ccc;
          border-radius: 4px;
          color: #333;
          background-color: #fff;
          white-space: nowrap;
          overflow-x: hidden;
          text-overflow: ellipsis;
          span {
            vertical-align: middle;
            float: left;
          }
          .nsdicon-angle-down {
            position: relative;
            font-size: large;
            float: right;
          }
        }
        .ngx-dropdown-button {
          font-family: 'Open Sans', sans-serif;
          font-size: 14px;
          color: #495057;
          width: 100%;
          min-height: 38px;
          padding: 5px 10px 5px 10px;
          background-color: white;
        }
        .ngx-dropdown-list-container {
          box-sizing: border-box;
          border: 1px solid rgba(0, 0, 0, 0.15);
          border-radius: 4px;
          padding-left: 10px;
          padding-right: 10px;
          z-index: 999999999;
          width: 350px;
          background-clip: padding-box;
          background: white;
          position: absolute;
          -webkit-box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.21);
          -moz-box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.21);
          box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.21);
          overflow-y: auto;
          &.drop-up {
            bottom: 100%;
            top: auto;
            box-shadow: 5px -5px 5px 0px rgba(0, 0, 0, 0.21);
          }
          .search-container {
            position: relative;
            padding-top: 10px;
            margin-top: 5px;
            input {
              background-color: transparent;
              border: none;
              border-bottom: 1px solid #9e9e9e;
              border-radius: 0;
              outline: none;
              height: 2rem;
              width: 100%;
              font-size: 13px;
              margin: 0;
              padding: 0;
              box-shadow: none;
              box-sizing: content-box;
              transition: all 0.3s;
              &:focus {
                border-bottom: 1px solid #26a69a;
              }
              &:focus + label {
                transform: translateY(-2px) scale(0.8);
                transform-origin: 0 0;
              }
            }
            label {
              color: #9e9e9e;
              position: absolute;
              top: 0;
              left: 0;
              height: 100%;
              font-size: 1rem;
              cursor: text;
              -webkit-transition: -webkit-transform 0.2s ease-out;
              transition: -webkit-transform 0.2s ease-out;
              transition: transform 0.2s ease-out;
              transition:
                transform 0.2s ease-out,
                -webkit-transform 0.2s ease-out;
              -webkit-transform-origin: 0% 100%;
              transform-origin: 0% 100%;
              text-align: initial;
              transform: translateY(12px);
              pointer-events: none;
              &.active {
                transform: translateY(-2px) scale(0.8);
                transform-origin: 0 0;
              }
            }
          }
          ul {
            margin-top: 1rem;
            margin-bottom: 1rem;
            list-style-type: none;
            padding-left: 0px;
            &.selected-items {
              li {
                background-color: #337ab7;
                color: white;
                margin-bottom: 2px;
              }
            }
            &.available-items {
              max-height: 390px;
              overflow-y: auto;
              li.active {
                background-color: #337ab7;
                color: #ffff;
              }
            }
            li {
              font-size: inherit;
              cursor: pointer;
              display: block;
              padding: 3px 20px;
              clear: both;
              font-weight: 400;
              line-height: 1.42857143;
              color: #333;
              white-space: normal;
            }
          }
        }
        .disabled {
          pointer-events: none;
          background-color: #e9ecef;
          opacity: 1;
          cursor: no-drop;
        }
      }
    `,
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MultiSelectInputComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class MultiSelectInputComponent implements OnInit, OnChanges, AfterViewInit {
  /** value of the dropdown */
  @Input() public _value: any;

  /**
   * Get the required inputs
   */
  @Input() public options: any = [];

  /**
   * configuration options
   */
  @Input() public config: any = {};

  /**
   * Whether multiple selection or single selection allowed
   */
  @Input() public multiple = false;

  /**
   * Value
   */
  @Input() public disabled: boolean;

  /**
   * Flat mode - when true, input/output will be IDs only
   */
  @Input() public flatMode = false;

  /**
   * change event when value changes to provide user to handle things in change event
   */
  @Output() public change: EventEmitter<any> = new EventEmitter();

  /**
   * change event when value changes to provide user to handle things in change event
   */
  @Output() public searchChange: EventEmitter<any> = new EventEmitter();

  /**
   * Event emitted when dropdown is open.
   */
  @Output() public open: EventEmitter<any> = new EventEmitter();

  /**
   * Event emitted when dropdown is open.
   */
  @Output() public close: EventEmitter<any> = new EventEmitter();

  /**
   * Toogle the dropdown list
   */
  public toggleDropdown = false;

  /**
   * Available items for selection
   */
  public availableItems: any = [];

  /**
   * Selected Items
   */
  public selectedItems: any = [];

  /**
   * Selection text to be Displayed
   */
  public selectedDisplayText = 'Select';

  /**
   * Search text
   */
  public searchText: string;

  /**
   * variable to track if clicked inside or outside of component
   */
  public clickedInside = false;

  /**
   * variable to track keypress event inside and outsid of component
   */
  public insideKeyPress = false;

  /**
   * variable to track the focused item whenuser uses arrow keys to select item
   */
  public focusedItemIndex: number = null;

  /**
   * element to show not found text when not itmes match the search
   */

  public showNotFound = false;
  /**
   * Hold the reference to available items in the list to focus on the item when scrolling
   */
  @ViewChildren('availableOption') public availableOptions: QueryList<ElementRef>;

  get value() {
    return this._value;
  }
  set value(val) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }

  constructor(
    private cdref: ChangeDetectorRef,
    public _elementRef: ElementRef,
  ) {
    this.multiple = false;
  }

  public onChange: any = () => {
    // empty
  };
  public onTouched: any = () => {
    // empty
  };
  public onSearchChanged: any = (event: any) => {
    this.searchChange.emit(event);
    if (this.config.backendSearch) {
      return;
    }
    const searchKey = this.config.searchOnKey || this.config.displayKey;
    const term = (event || '').toLowerCase();
    const unselected = this.options.filter(item => !this.selectedItems.includes(item));
    this.availableItems = term
      ? unselected.filter(item => (item[searchKey] || item).toString().toLowerCase().includes(term))
      : [...unselected.sort(this.config.customComparator)];
  };

  /**
   * click listener for host inside this component i.e
   * if many instances are there, this detects if clicked inside
   * this instance
   */
  @HostListener('click')
  public clickInsideComponent() {
    this.clickedInside = true;
  }

  /**
   * click handler on documnent to hide the open dropdown if clicked outside
   */
  @HostListener('document:click')
  public clickOutsideComponent() {
    if (!this.clickedInside) {
      this.toggleDropdown = false;
      this.resetArrowKeyActiveElement();
    }
    this.clickedInside = false;
  }

  /**
   * click handler on documnent to hide the open dropdown if clicked outside
   */
  @HostListener('document:keydown')
  public KeyPressOutsideComponent() {
    if (!this.insideKeyPress) {
      this.toggleDropdown = false;
      this.resetArrowKeyActiveElement();
    }
    this.insideKeyPress = false;
  }
  /**
   * Event handler for key up and down event and enter press for selecting element
   * @param event
   */
  @HostListener('keydown', ['$event'])
  public handleKeyboardEvent($event: KeyboardEvent) {
    this.insideKeyPress = true;
    if ($event.keyCode === 27 || this.disabled) {
      this.toggleDropdown = false;
      this.insideKeyPress = false;
      return;
    }
    const avaOpts = this.availableOptions.toArray();
    if (avaOpts.length === 0 && !this.toggleDropdown) {
      this.toggleDropdown = true;
    }
    // Arrow Down
    if ($event.keyCode === 40 && avaOpts.length > 0) {
      this.onArrowKeyDown();
      avaOpts[this.focusedItemIndex].nativeElement.focus();
      $event.preventDefault();
    }
    // Arrow Up
    if ($event.keyCode === 38 && avaOpts.length) {
      this.onArrowKeyUp();
      avaOpts[this.focusedItemIndex].nativeElement.focus();
      $event.preventDefault();
    }
    // Enter
    if ($event.keyCode === 13 && this.focusedItemIndex !== null) {
      this.selectItem(this.availableItems[this.focusedItemIndex], this.focusedItemIndex);
      return false;
    }
  }

  /**
   * Component onInit
   */
  public ngOnInit() {
    if (typeof this.options !== 'undefined' && Array.isArray(this.options)) {
      this.availableItems = [...this.options.sort(this.config.customComparator)];
      this.initDropdownValuesAndOptions();
    }
  }

  /**
   * after view init to subscribe to available option changes
   */
  public ngAfterViewInit() {
    this.availableOptions.changes.subscribe(this.setNotFoundState.bind(this));
  }

  /**
   * Programmatically replace the whole selection from outside the component and refresh the
   * display. `value` follows the same contract as the form value (ids in flat mode, option
   * objects otherwise). Optionally pass a fresh `options` list so newly selected items that were
   * not part of the previous option set are known to the dropdown.
   */
  public setSelection(value: any, options?: any) {
    if (options) {
      this.options = options;
      this.availableItems = [...options];
    }
    this.selectedItems = [];
    this.writeValue(value);
  }

  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  public writeValue(value: any) {
    /* istanbul ignore else */
    console.log(value);
    if (value !== null && value !== undefined) {
      if (this.flatMode) {
        // In flat mode, convert IDs to full objects for internal use
        this.selectedItems = this.convertIdsToObjects(value);
        this.value = value;
      } else {
        if (Array.isArray(value)) {
          if (this.multiple) {
            this.value = value;
          } else {
            this.value = value[0];
          }
        } else {
          this.value = value;
        }
        /* istanbul ignore else */
        if (this.selectedItems.length === 0) {
          if (Array.isArray(value)) {
            this.selectedItems = value;
          } else {
            this.selectedItems.push(value);
          }
        }
      }
      this.initDropdownValuesAndOptions();
    }
  }

  /**
   * Convert IDs to full objects (for flat mode)
   */
  private convertIdsToObjects(ids: any): any[] {
    if (!this.flatMode || !this.options) {
      return [];
    }

    const idArray = Array.isArray(ids) ? ids : [ids];
    return this.options.filter(option => {
      const optionId = typeof option === 'object' ? option.id : option;
      return idArray.includes(optionId);
    });
  }

  /**
   * Convert objects to IDs (for flat mode output)
   */
  private convertObjectsToIds(objects: any[]): any {
    if (!this.flatMode || !objects || objects.length === 0) {
      return this.multiple ? [] : null;
    }

    const ids = objects.map(obj => {
      return typeof obj === 'object' ? obj.id : obj;
    });

    return this.multiple ? ids : ids[0];
  }

  /**
   * function sets whether to show items not found text or not
   */
  public setNotFoundState() {
    if (this.availableOptions.length === 0) {
      this.showNotFound = true;
    } else {
      this.showNotFound = false;
    }
    this.cdref.detectChanges();
  }
  /**
   * Component onchage i.e when any of the input properties change
   * @param changes
   */
  public ngOnChanges(changes: SimpleChanges) {
    // this.selectedItems = [];
    // this.searchText = null;
    this.options = this.options || [];
    if (changes.options) {
      this.availableItems = [...this.options.sort(this.config.customComparator)];
    }
    if (changes.value && JSON.stringify(changes.value.currentValue) === JSON.stringify([])) {
      this.availableItems = [...this.options.sort(this.config.customComparator)];
    }
    this.initDropdownValuesAndOptions();
  }

  /**
   * Deselct a selected items
   * @param item:  item to be deselected
   * @param index:  index of the item
   */
  public deselectItem(item: any, index: number) {
    this.selectedItems.splice(index, 1);
    this.selectedItems = [...this.selectedItems];
    // rebuild from the original options so a deselected item returns to its natural position
    // instead of being appended to the bottom (sort(undefined) is a no-op on objects, so the old
    // push+sort left it stuck at the end)
    this.rebuildAvailableItems();
    this.valueChanged();
    this.resetArrowKeyActiveElement();
  }

  private itemKey(item: any) {
    return item && typeof item === 'object' ? item.id : item;
  }

  private rebuildAvailableItems() {
    const selectedKeys = new Set(this.selectedItems.map((selected: any) => this.itemKey(selected)));
    this.availableItems = (this.options || []).filter((option: any) => !selectedKeys.has(this.itemKey(option)));
    if (this.config.customComparator) {
      this.availableItems.sort(this.config.customComparator);
    }
  }

  /**
   * Select an item
   * @param item:  item to be selected
   * @param index:  index of the item
   */
  public selectItem(item: string, index?: number) {
    if (!this.multiple) {
      if (this.selectedItems.length > 0) {
        this.availableItems.push(this.selectedItems[0]);
      }
      this.selectedItems = [];
      this.toggleDropdown = false;
    }
    this.availableItems.splice(index, 1);
    this.selectedItems.push(item);
    this.selectedItems = [...this.selectedItems];
    this.availableItems = [...this.availableItems];
    this.selectedItems.sort(this.config.customComparator);
    this.availableItems.sort(this.config.customComparator);
    // this.writeValue(this.selectedItems);
    this.valueChanged();
    this.resetArrowKeyActiveElement();
  }

  /**
   * When selected items changes trigger the chaange back to parent
   */
  public valueChanged() {
    if (this.flatMode) {
      // In flat mode, emit only IDs
      const outputValue = this.convertObjectsToIds(this.selectedItems);
      this.writeValue(outputValue);
      this.change.emit({value: outputValue});
    } else {
      this.writeValue(this.selectedItems);
      this.change.emit({value: this.value});
    }
    this.setSelectedDisplayText();
  }

  /**
   * Toggle the dropdownlist on/off
   */
  public toggleSelectDropdown() {
    this.toggleDropdown = !this.toggleDropdown;
    if (this.toggleDropdown) {
      this.open.emit();
    } else {
      this.close.emit();
    }
    this.resetArrowKeyActiveElement();
  }

  /**
   * initialize the config and other properties
   */
  private initDropdownValuesAndOptions() {
    const config: any = {
      displayKey: 'description',
      height: 'auto',
      search: false,
      placeholder: 'Select',
      searchPlaceholder: 'Search',
      limitTo: this.options.length,
      customComparator: undefined,
      noResultsFound: 'No results found!',
      moreText: 'more',
      searchOnKey: null,
    };
    if (this.config === 'undefined' || Object.keys(this.config).length === 0) {
      this.config = {...config};
    }
    for (const key of Object.keys(config)) {
      this.config[key] = this.config[key] ? this.config[key] : config[key];
    }
    // Adding placeholder in config as default param
    this.selectedDisplayText = this.config['placeholder'];
    if (this.value !== '' && typeof this.value !== 'undefined') {
      if (this.flatMode) {
        // In flat mode, convert IDs to objects for internal display
        this.selectedItems = this.convertIdsToObjects(this.value);
      } else {
        if (Array.isArray(this.value)) {
          this.selectedItems = this.value;
        } else {
          this.selectedItems[0] = this.value;
        }
      }

      this.selectedItems.forEach((item: any) => {
        const ind = this.availableItems.findIndex((aItem: any) => JSON.stringify(item) === JSON.stringify(aItem));
        if (ind !== -1) {
          this.availableItems.splice(ind, 1);
        }
      });
    }
    this.setSelectedDisplayText();
  }

  /**
   * set the text to be displayed
   */
  private setSelectedDisplayText() {
    let text: string = this.selectedItems[0];
    if (typeof this.selectedItems[0] === 'object') {
      text = this.selectedItems[0][this.config.displayKey];
    }

    if (this.multiple && this.selectedItems.length > 0) {
      this.selectedDisplayText =
        this.selectedItems.length === 1 ? text : text + ` + ${this.selectedItems.length - 1} ${this.config.moreText}`;
    } else {
      this.selectedDisplayText = this.selectedItems.length === 0 ? this.config.placeholder : text;
    }
  }

  /**
   * Event handler for arrow key up event thats focuses on a item
   */
  private onArrowKeyUp() {
    if (this.focusedItemIndex === 0) {
      this.focusedItemIndex = this.availableItems.length - 1;
      return;
    }
    if (this.onArrowKey()) {
      this.focusedItemIndex--;
    }
  }

  /**
   * Event handler for arrow key down event thats focuses on a item
   */
  private onArrowKeyDown() {
    if (this.focusedItemIndex === this.availableItems.length - 1) {
      this.focusedItemIndex = 0;
      return;
    }
    if (this.onArrowKey()) {
      this.focusedItemIndex++;
    }
  }

  private onArrowKey() {
    if (this.focusedItemIndex === null) {
      this.focusedItemIndex = 0;
      return false;
    }
    return true;
  }

  /**
   * will reset the element that is marked active using arrow keys
   */
  private resetArrowKeyActiveElement() {
    this.focusedItemIndex = null;
  }
}
